import api from './api';

// Fiches de révision papier (envoi postal) — côté élève.
export const revisionSheetService = {
    async getStatus() {
        try {
            const response = await api.get('/revision-sheets.php', { params: { action: 'status' } });
            return response.data;
        } catch (error) {
            console.error('API Error (Revision sheets status):', error);
            throw error;
        }
    },

    async submit(data) {
        // Pas de catch silencieux : le formulaire affiche l'erreur backend (validation adresse…)
        const response = await api.post('/revision-sheets.php?action=submit', data);
        return response.data;
    },
};

export default revisionSheetService;
